import useSWR from "swr"
import PricingService from "services/guests/pricing.service"

const useIndex = () => {
  const { data, errors } = useSWR(
    PricingService.index.key(),
    PricingService.index.handler,
  )
  const isLoading = !data && !errors
  const courses = data && data.courses && data.courses.data
  const coursesErrors = data && data.courses && data.courses.errors

  console.log("useIndex: data", data)

  return {
    courses,
    errors: errors || coursesErrors,
    isLoading,
  }
}

export default useIndex
